import isNil from 'lodash/isNil';

const toDoAvatarClasses = [
  '!bg-amber-300 !text-amber-950',
  '!bg-fuchsia-300 !text-fuchsia-950',
  '!bg-sky-300 !text-sky-950',
  '!bg-emerald-300 !text-emerald-950',
  '!bg-orange-300 !text-orange-950',
  '!bg-violet-300 !text-violet-950',
] as const;

export default function getToDoAvatarClass(userId?: number | null) {
  if (isNil(userId)) {
    return toDoAvatarClasses[0];
  }

  return toDoAvatarClasses[Math.abs(userId) % toDoAvatarClasses.length];
}
